import React, { useEffect } from "react";
import { string, func } from "prop-types";
import RightMarkIcon from "../../../atoms/RightMarkIcon";

import "./login-toast.m.css";

const ToastMessage = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div styleName="login-toast">
      <RightMarkIcon />
      <span styleName="text">{message}</span>
    </div>
  );
};

ToastMessage.propTypes = {
  message: string,
  onClose: func,
};

export default ToastMessage;
